import script from "./Summary16167Choices.vue?vue&type=script&setup=true&lang=ts"
export * from "./Summary16167Choices.vue?vue&type=script&setup=true&lang=ts"

import "./Summary16167Choices.vue?vue&type=style&index=0&id=a6b6f8ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6b6f8ee"]])

export default __exports__